import { useEffect, useState, useContext, useCallback } from 'react';
import { AuthContext } from '../context/AuthContext';

export function useScrapeNotifications() {
  const { token } = useContext(AuthContext);
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    if (!token) return;

    const wsUrl = process.env.REACT_APP_WS_URL || 'ws://localhost:8000/ws/scrape-notifications/';
    let ws = null;
    let reconnectTimer = null;
    let disposed = false;

    const attachHandlers = (socket) => {
      socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.type === 'scrape_complete') {
          setNotification(data);
        }
      };

      socket.onclose = () => {
        if (disposed) return;
        // Token may have refreshed — reconnect with latest token after brief delay
        const latestToken = localStorage.getItem('token');
        if (latestToken) {
          reconnectTimer = setTimeout(() => {
            if (disposed) return;
            ws = new WebSocket(`${wsUrl}?token=${latestToken}`);
            attachHandlers(ws);
          }, 2000);
        }
      };

      socket.onerror = (err) => console.error('WebSocket error:', err);
    };

    ws = new WebSocket(`${wsUrl}?token=${token}`);
    attachHandlers(ws);

    return () => {
      disposed = true;
      if (ws) ws.close();
      if (reconnectTimer) clearTimeout(reconnectTimer);
    };
  }, [token]);

  const clearNotification = useCallback(() => setNotification(null), []);

  return { notification, clearNotification };
}
